import {cgiUnescape} from "./cgiUnescape"
import {EmbedCodeExtractor} from "./types"

/** Patterns of Tik::WebEmbedService::PreProcessor::Infogram (pre_processor/infogram.rb). */
const PATTERNS = [
  /src="(https?:\/\/infogram.com\/\S+)"/i
]

/**
 * Extracts the (possibly percent-encoded) infogram.com URL from an iframe embed code
 * and CGI-unescapes it (pre_processor/infogram.rb; shared isomorphic decoder, design D5).
 */
export const infogramPreProcessor: EmbedCodeExtractor = (input: string) => {
  for(const pattern of PATTERNS) {
    const match = pattern.exec(input)
    if(match) {
      return cgiUnescape(match[1])
    }
  }
  return null
}
